module.exports = __webpack_public_path__ + "assets/img/img266.42b4d9f3.png";